<template>
  <div class="page">
    <div class="page-content">
			<div class="layoutTop"/>
      <page-nav-bar
        popoverName=""
        :subNavTitle="ServiceDetails"
        ReturnButton>
      </page-nav-bar>
      <div class="container-fluid">

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">
              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <div v-if="details.direction === '0'">
                    <img src='../../../assets/static/images/icons/inbox_into.png' class="formIcon"/>
                    {{ $t('received.rcvd_verb_past', {itemname: $t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))}) }}
                  </div>
                  <div v-if="details.direction === '1'">
                    <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                    {{ $t('sent.snt_verb_past', {itemname: $t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))}) }}
                  </div>
                </h4>
              </div>

                <div class="accordion-item accordion-item-expanded accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" :class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto text-uppercase">
                              {{ ServiceDetails }}
                              <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="row">
                      <form-read-group-label-input
                        :idLabel="$t('common.rsn')" :inputValue="details.remittanceInformation">
                      </form-read-group-label-input>
                      <form-read-group-label-input
                        :idLabel="$t('common.idtfr')" :inputValue="details.endToEndId">
                      </form-read-group-label-input>
                    </div>

                    <div class="row">
                      <form-read-group-label-input
                        :idLabel="$t('common.rqst_date')" :inputValue="details.requestedExecutionDate | formatDate">
                      </form-read-group-label-input>
                      <form-read-group-label-input
                        :idLabel="$t('common.status.status_label')"
                        :inputValue="getStatusLabel(details.status, details.direction)"
                        :statusIcon="getIcon(details.status, '0')">
                        <f7-button
                          class="blueBackground col-12 col-sm-6 pain001ViewerButton"
                          @click="viewXML('pain001', details.endToEndId)"
                          v-if="details.status === '4' && details.direction === '1'">
                          View Transfer Order File
                        </f7-button>
                        <f7-button
                          class="blueBackground col-12 col-sm-6 pain001ViewerButton"
                          @click="viewXML('pacs008', details.endToEndId)"
                          v-if="details.status === '5' && details.direction === '1'">
                          View Instant Payment File
                        </f7-button>
                      </form-read-group-label-input>
                    </div>

                    <div class="form-group row">
                      <form-read-group-label-input
                        :idLabel="$t('common.total_amount_no_currency')"
                        :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)">
                      </form-read-group-label-input>
                      <div class="form-group row"
                          v-if="details.attachmentId !== ''">
                        <div class="col-md-3" :class="colorBottomButton">
                          <button round
                          @click="view(details.attachmentId)"
                          class="button-action firstButtonMarginTop"
                          v-if="ifAndroid">
                            <i class="icon fa fa-paperclip"></i>
                            View Attachment
                          </button>
                          <button round
                            v-if="!ifAndroid"
                            @click="view(details.attachmentId)"
                            class="button-action firstButtonMarginTop">
                              <i class="icon fa fa-paperclip"></i>
                              Download Attachment
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              <hr/>

                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" :class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '0'">
                            MY ACCOUNT INFORMATION
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                          <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '1'">
                            BENEFICIARY INFORMATION
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="row">
                      <form-read-group-label-input
                        :idLabel="$t('common.nme')" :inputValue="details.creditorName">
                      </form-read-group-label-input>
                      <form-read-group-label-input
                        :idLabel="$t('common.idtfr')" :inputValue="details.creditorIdentifier">
                      </form-read-group-label-input>
                    </div>
                    <!-- Affichage IBAN, ou Sort Code & accountNumber, etc -->
                    <div
                      class="row"
                      v-for="accountData in bankLabelHidden(details.creditorBankAccount, details.creditorZoneCode)">
                      <form-read-group-label-input
                        :idLabel="$t(accountData.labelId)" :inputValue="accountData.hiddenValue">
                      </form-read-group-label-input>
                    </div>
                  </div>
                </div>

            <hr />

                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" :class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '0'">
                              SENDER INFORMATION
                              <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                          <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '1'">
                            MY ACCOUNT INFORMATION
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="row">
                      <form-read-group-label-input
                        :idLabel="$t('common.nme')" :inputValue="details.debtorName">
                      </form-read-group-label-input>
                      <form-read-group-label-input
                        :idLabel="$t('common.idtfr')" :inputValue="details.debtorIdentifier">
                      </form-read-group-label-input>
                    </div>

                    <div
                      class="form-group row"
                      v-for="debtorAccountData in bankLabelHidden(details.debtorBankAccount, details.debtorZoneCode)">
                        <form-read-group-label-input
                          :idLabel="$t(debtorAccountData.labelId)" :inputValue="debtorAccountData.hiddenValue">
                        </form-read-group-label-input>
                    </div>
                  </div>
                </div>

            <hr/>

                  <div class="accordion-item accordionForm">
                    <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                      <div class="item-inner" :class="colorBottomButton">
                        <div class="form-group row justify-content-start">
                            <div class="item-title createInvoiceBand col-sm-auto">
                                DIRECT PAYMENT HISTORY
                                <i class="f7-icons formChevron">chevron_right</i>
                            </div>
                        </div>
                      </div>
                    </a>

                  <div class="accordion-item-content" v-if="details.history.length > 0">
                    <div class="form-group row">
                      <div class="col-12">
                        <table class="table table-striped table-bordered table-status-history">
                          <thead class="thead-dark">
                            <tr>
                              <th scope="col" class='reponsiveColumnWidth'>Date</th>
                              <th scope="col">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="record in details.history" :key="record.id">
                              <td>{{record.creationDate | formatDateTime}}</td>
                              <td>
                                <span>{{getStatusLabel(record.status, details.direction)}}
                                  <i class="icon icon-transaction-detail" :class="getIcon(record.status,0)"></i>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="transactionDetailFontSize">
                          <li class="item-content" v-if="(details.status==='1' || details.status==='2' || details.status==='3') && details.responseComment !== ''">
                            <div class="item-inner" style="display:block;">
                              <div class="item-title-row">
                                Response Comment:
                              </div>
                              <div class="item-title-row">
                                <div style="color:#8e8e93">{{details.responseComment}}</div>
                              </div>
                            </div>
                          </li>
                        </div>

                        <div class="item-content" v-if="(details.status==='1' || details.status==='2' || details.status==='3') && details.responseComment !== ''">
                          <div class="item-inner" style="display:block;">
                            <div class="item-title-row">
                              <div>Response Comment:</div>
                            </div>
                            <div class="item-title-row">
                              <div style="color:#8e8e93">{{details.responseComment}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>


              <hr v-if="details.validators.length > 0"/>

              <div v-if="details.validators.length > 0">
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" :class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                              VALIDATION
                              <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                <div class="accordion-item-content">
                  <div class="form-group row">
                    <div class="col-12">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Group</th>
                            <th scope="col">Group Member</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="validator in details.validators" :key="validator.groupLabel">
                            <td  class="showLargeScreenOnly" style="padding-right: 30px;">{{validator.horodatage | formatDateTime}}</td>
                            <td  class="showSmallScreenOnly">{{validator.horodatage | formatDateTime}}</td>
                            <td>{{validator.groupLabel}}</td>
                            <td class="longword">{{validator.identifier}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      <!-- comment: Buttons -->
      <div v-if="details.direction === '0' && details.status === '0'" class="inboxDetailButton">
				<div class="row justify-content-start">
          <div class="offset-md-5 col-md-3" style="margin-top: 10px;">
            <div style="padding: 0px 10px 10px 10px;">
              <f7-button
              style="background-color:#51a45c; color:white;border-color:#51a45c"
              @click="acceptDP()">
                Accept
              </f7-button>
            </div>
          </div>
          <div class="col-md-3" style="margin-top: 10px;">
            <div style="padding: 0px 10px 10px 10px;">
              <f7-button
              style="background-color:#e53f4e; color:white;border-color:#e53f4e"
              @click="refuseDP()">
                Refuse
              </f7-button>
            </div>
          </div>
        </div>
			</div>



    </div> <!-- End Container Fluid -->
      <div class="layoutBottom"></div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
		<!-- </f7-page> -->
	<!-- </div> -->
</template>

<script>
import moment from 'moment'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import b64toBlob from 'b64-to-blob'
import {loadPage} from '@/helpers/routing'
import {statusLabel, statusIcon} from '@/helpers/labels'
import {extractForeignIban} from '@/helpers/format'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'

export default {
  name: 'directPayments-details',
  props: ['direction'],
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      details: {},
      ServiceDetails: ''
    }
  },
  created () {
    this.ServiceDetails = this.$i18n.t('common.item_details',
      {itemname: this.$i18n.t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))})
    if (this.direction === '0') {
      this.details = this.$engine.services.directPayments.currentInbox
    } else {
      this.details = this.$engine.services.directPayments.currentSendbox
    }

    this.zoneData = this.$engine.bankAccounts.getZoneData(this.details.creditorZoneCode)
  },
  mounted () {
    /* TLV 18/12/2019
    * Sur grand écran, les accordéons sont étendus par défaut, tandis qu'ils sont repliés sur mobile
    */
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
  },
  computed: {
    ifAndroid: function () {
      if (this.$f7.device.os === 'android') {
        return true
      } else {
        return false
      }
    },
    senderCurrency: function () {
      if (this.direction === '0') {
        return this.details.senderCurrency
      } else {
        return this.details.currency
      }
    }
  },
  methods: {
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(-90deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(-90deg)')
        }
      }
      // that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top - that.$$('.page-content').offset().top + that.$$('.page-content').scrollTop() + 300, 400)
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    },
    getStatusLabel (status, direction) {
      return statusLabel(this.$i18n, status, -1, direction)
    },
    getIcon (status, negotStatus) {
      return statusIcon(status, negotStatus)
    },
    /* Only work for downloading files on Mobile devices */
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(filePath.split('/')[filePath.split('/').length - 1], 'Following file successfully saved.')
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    view: function (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else {
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    viewXML: function (type, id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let service = 'directPayment'
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getXMLDetail(service, type, id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({type: {
            data: response.data.data
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              service + '_' + type + '_' + id + '.xml',
              response.data.data,
              response.data.data.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              })
          } else { // browser
            let blob = b64toBlob(response.data.data.split(',')[1], 'text/xml')
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            let today = moment().format()
            let filename = 'Transfer_Order_' + today
            if (type === 'pacs008') {
              filename = 'Instant_Payment_' + today
            }
            fileLink.setAttribute('download', filename) // or any other extension
            fileLink.click()
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          console.log(error)
          // errorMessageAlert(error, that)
        })
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    console.error('error on saving file' + error.code)
                    alert('Unable to save file: ' + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(function (status) {
          switch (status) {
            case cordova.plugins.diagnostic.permissionStatus.GRANTED:
              console.log('Permission granted')
              sucess()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED:
              console.log('Permission denied')
              error()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
              console.log('Permission permanently denied')
              error()
              break
          }
        }, function (error) {
          console.error('The following error occurred: ' + error)
        },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists do you want to override it ? (' + fileName + ')', function (index) {
            console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
    },
    returnBack () {
      this.$f7.mainView.router.back()
    },
    acceptDP () {
      let that = this
      this.$engine.services.directPayments.answerDP(
        that.details.creditorIdentifier,
        that.details.creditorName,
        that.details.creditorBankAccount,
        that.details.debtorIdentifier,
        that.details.debtorName,
        that.details.debtorBankAccount,
        'ACSP',
        '',
        that.details.amount,
        that.details.currency,
        that.details.requestedExecutionDate,
        that.details.remittanceInformation,
        that.details.endToEndId,
        that.details.id,
        that.details.creditorZoneCode,
        that.details.debtorZoneCode
      ).then(response => {
        loadPage(that, {url: '/directPayments/inbox/'})
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    refuseDP () {
      let that = this
      this.$engine.services.directPayments.answerDP(
        that.details.creditorIdentifier,
        that.details.creditorName,
        that.details.creditorBankAccount,
        that.details.debtorIdentifier,
        that.details.debtorName,
        that.details.debtorBankAccount,
        'RJCT',
        '',
        that.details.amount,
        that.details.currency,
        that.details.requestedExecutionDate,
        that.details.remittanceInformation,
        that.details.endToEndId,
        that.details.id,
        that.details.creditorZoneCode,
        that.details.debtorZoneCode
      ).then(response => {
        loadPage(that, {url: '/directPayments/inbox/'})
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getCurrencyIcon (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'AUD':
          return 'A$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        default:
          return ccy
      }
    },
    bankLabelHidden (iban, zone) {
      return extractForeignIban(iban, zone)
    },
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    }
  }
}
</script>
<style scoped>
	.transaction-info {
		/* padding-top: 50px; */
		padding-left: 3%;
		padding-right: 3%;
		width: 94%;
		/* height: 100%; */
		max-height: 100%;
		clear: both;
		margin: 0 auto;
	}
	.modify-actions {
	}
	.changesGrid {
		border-top: 2px solid #fffdb7;
		border-bottom: 2px solid #fffdb7;
		font-weight: bold;
		text-align: center;
		background-color: #fffdb7;
	}
	.firstGridModif {
		border-top: 1px solid #E36608;
		border-bottom: 1px solid #E36608;
		font-weight: bold;
		text-align: center;
		border-radius: 0px 0px 0 0;
		margin-top: 3%;
	}
	.titleGridModif {
		color: #ffffff;
		background-color: #E36608;
		border-radius: 0px 0px 0 0;
	}
	.defaultGridDisplayModif {
		border-left: 2px solid orange;
		border-right: 2px solid orange;
		background-color: #ffffff;
	}
	.lastGridModif {
		border-bottom: 1px solid #12bcf1;
	}
  .zeroHight {
    height: 0px;
  }
  .titleGridExecuted {
    color: #ffffff;
		background-color: #46C03D;
		border-radius: 0px 0px 0 0;
  }
  .subTitlePaymentsInfo {
    color: #000000;
    /* padding: 3px 0px 9px 1%; */
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .iconDetailsPage {
    font-size:15px;
    padding-left:5px;
  }
  .colorRemittanceInfomation {
    color:#144a85
  }
  .bankAccountPaymentsSelectionList {
    /* display: none;
    position: absolute;
    background-color: #f9f9f9; */
    margin:0px;
    list-style: none;
    padding-left: 0 !important;
    max-height: 96px;
    overflow:hidden;
    overflow-y:scroll;

    /* -webkit-appearance: none;
    width: 7px; */
  }
  .bankAccountPaymentsSelectionListContainer{
    display: none;
    position: absolute;
    right: 10px;
    top: 25px;
    /* bottom: 0px; */
    margin-top: 1px;
    background-color: #ffffff;
    border: 1px solid #a9a9a9;
    min-width: 206px;
    z-index: 20;
  }
  .bankAccountPaymentsSelectionInput {
    /* width: 215px; */
    font-size: 12px !important;
    height: auto !important;
    width: 190px !important;
  }
  .bankAccountPaymentsSelectionListItem {
    padding: 8px 8px;
  }
  .closeSelectionListContainerLabel {
    padding: 3px 8px 3px 8px;
    /* text-align: right; */
    /* height: 29px; */
    border-bottom: 1px solid #a9a9a9;
  }
  .rightButton {
    /* float: right; */
    right: 8px;
    top: 3px;
    /* width: 60px; */
    padding: 1px 5px !important;
    position: absolute;
    line-height: normal !important;
  }
  .bankAccountPaymentsSelectionList::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
  }
  .bankAccountPaymentsSelectionList::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
  .closeSelectionListContainerLabelName {
    line-height: 21px;
  }
  .pain001ViewerBlock {
    display: block !important;
  }
  .pain001ViewerButtonBlock {
    margin-right: 7px !important;
    float: right !important;
    position: relative !important;
    color: #777777;
  }
	/*.button {
		margin-top: 5px;
		margin-bottom: 5px;
	}*/
  .transactionDetailFontSize {
    font-size: 16px !important;
  }
  .transactionDetailHeader{
    color:white;
    background-color: #12bcf1;
    text-align: center;
    font-size: 14px;
    display: block;
    min-height: 0 !important;
    padding: 8px 15px !important;
    /* font-weight: bold; */
  }
  .transactionDetailSubHeader {
    text-align: center !important;
    display: block !important;
    font-weight: bold !important;
  }
  .icon-transaction-detail {
    width: 18px;
    height: 18px;
    background-size: contain;
  }
  .headerChevron {
    float: right;
    font-size: 12px;
    margin-top: 4px;
  }
  .list-block li {
    background-color: #fcfcfc;
  }
  .list-block.item-content {
    padding-left: 0% !important;
  }
  .list-block.inset {
    margin-left: 0%;
  }
</style>



// WEBPACK FOOTER //
// DirectPaymentDetailPage.vue?6cc64636